var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.031,
    height: 28.027,
    viewBox: "0 0 31.031 28.027",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_40604",
    x: 0,
    y: 0,
    width: 31.031,
    height: 28.027,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_40604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40604-2",
    "data-name": "Path 40604",
    d: "M-172.63,371.871V396.81h15.094V371.871Zm6.273,18.525h-3.369v-3.37h3.369Zm0-5.8h-3.369v-3.369h3.369Zm0-5.8h-3.369V375.42h3.369Zm5.826,11.606H-163.9v-3.37h3.369Zm0-5.8H-163.9v-3.369h3.369Zm0-5.8H-163.9V375.42h3.369Zm15.931,4.83V396.9h-3.518v-7h-5.253v7h-3.518V383.62Zm0-2.445h-12.289v1.85H-144.6Z",
    transform: "translate(174.13 -371.37)",
    fill: "#3c3c3b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/Building.6acd82fd55a321df7c78697d15d6c2e6.svg";
export { ForwardRef as ReactComponent };